<template>
  <div class="root">
    <Header @show-sidebar="false" />
    <div class="container">
      <Row>
        <Col span="4"></Col>
        <Col span="16">
          <Row>
            <Button @click="previousPage">← 戻る</Button>
          </Row>
          <Row style="padding: 10px">
            <h1>定型文の管理</h1>
            <Col span="1"></Col>
            <Button @click="createListModal.show = true" type="primary"
              >＋定型文リストを新規作成</Button
            >
          </Row>
          <Row>
            <Col span="24">
              <div
                v-if="sortedFixedJournalLists.length == 0"
                style="background: #eee; padding: 300px"
              >
                定型文はありません
              </div>
              <div v-else>
                <Row style="padding-left: 25px; padding-right: 25px;">
                  <a v-for="(fixedJournalList, index) in sortedFixedJournalLists"
                    @click="jumpToListOf(index)"
                    style="text-decoration: underline; margin-right: 10px;">
                      {{fixedJournalList.name}}
                  </a>
                </Row>

                <draggable v-model="sortedFixedJournalLists">
                  <transition-group type="transition" class="two-columns">
                    <Card
                      v-for="(fixedJournalList, index) in sortedFixedJournalLists"
                      :id="fixedJournalList.id"
                      :key="fixedJournalList.id"
                      :ref="'fixed_journal_list_' + index"
                      class="sortable"
                      style="margin: 15px"
                    >
                    <template #title>
                      <Row style="padding-top: 8px; padding-right: 6px; font-size: 22px;">
                        <div class="text">{{ omitDisplayName(fixedJournalList.name) }}</div>
                      </Row>
                      <Row align="middle" justify="end" style="margin-top: 10px;">
                          <Button
                              icon="md-add"
                              @click="setCreateModalTarget(fixedJournalList.id)"
                          >
                              定型文の追加
                          </Button>
                          <Dropdown>
                              <a href="javascript:void(0)">
                                  <Button>
                                      <Icon type="md-arrow-dropdown"></Icon>
                                  </Button>
                              </a>
                              <template #list>
                                <DropdownMenu>
                                  <DropdownItem>
                                    <a
                                      @click="
                                        setEditListModalTarget(fixedJournalList)
                                      "
                                      >リスト名の変更</a
                                    >
                                  </DropdownItem>
                                  <DropdownItem>
                                    <a
                                      @click="
                                        setEditColorModalTarget(
                                          fixedJournalList
                                        )
                                      "
                                    >
                                      背景色を変更
                                    </a>
                                  </DropdownItem>
                                  <DropdownItem>
                                    <a
                                      @click="
                                        setDeleteListModalTarget(
                                          fixedJournalList
                                        )
                                      "
                                      >リストの削除</a
                                    >
                                  </DropdownItem>
                                </DropdownMenu>
                              </template>
                            </Dropdown>
                        </Row>
                        <Row justify="end">
                          <Col></Col>
                          <Col>
                            <p style="font-weight: normal; font-size: 14px">
                              更新日時:
                              {{
                                fixedJournalList.modified_at
                                  | formatDate('YYYY-MM-DD HH:mm:ss')
                              }}
                            </p>
                          </Col>
                        </Row>
                      </template>
                      <List
                        v-if="fixedJournalList.fixed_journals.length == 0"
                        header="定型文はありません"
                        class="empty"
                      >
                      </List>
                      <List v-else border size="small">
                        <div class="list-item-container">
                          <draggable
                            :list="sortedFixedJournals(fixedJournalList)"
                            @change="updateFixedJournalOrder"
                          >
                            <transition-group>
                              <ListItem
                                v-for="fixedJournal in sortedFixedJournals(
                                  fixedJournalList
                                )"
                                :key="fixedJournal.id"
                                class="sortable fixed-journal"
                              >
                                <p class="text">
                                  {{ omitDisplayName(fixedJournal.name) }}
                                </p>
                                <div class="space"></div>
                                <div style="white-space: nowrap;">
                                  <a
                                    class="blue action"
                                    @click="
                                      setEditModalTarget(
                                        fixedJournalList.id,
                                        fixedJournal
                                      )
                                    "
                                  >
                                    <Icon type="md-create"></Icon>
                                    編集
                                  </a>
                                  <a
                                    class="red action"
                                    @click="
                                      setDeleteModalTarget(
                                        fixedJournalList.id,
                                        fixedJournal
                                      )
                                    "
                                  >
                                    <Icon type="md-trash" />
                                    削除
                                  </a>
                                </div>
                              </ListItem>
                            </transition-group>
                          </draggable>
                        </div>
                      </List>
                    </Card>
                  </transition-group>
                </draggable>
              </div>
            </Col>
          </Row>
          <Modal v-model="createListModal.show" :closable="false" footer-hide>
            <Row>
              <Col span="24">
                <p
                  style="
                    font-size: 16px;
                    font-weight: bold;
                    padding: 0 0 12px;
                    white-space: pre-line;
                  "
                >
                  定型文リストを作成
                </p>
              </Col>
            </Row>
            <Form>
              <FormItem label="リストの名前">
                <Input
                  v-model="createListModal.data.name"
                  ref="nameOfListToBeCreated"
                ></Input>
              </FormItem>
            </Form>
            <Row style="margin: 24px 0 0">
              <Col span="24">
                <Button type="text" @click="createListModal.show = false"
                  >キャンセル</Button
                >
                <Button
                  type="primary"
                  style="float: right"
                  @click="createFixedJournalList"
                  :disabled="
                    createListModal.data.name == null ||
                    isEmpty(createListModal.data.name)
                  "
                  >作成する</Button
                >
              </Col>
            </Row>
          </Modal>
          <Modal v-model="editListModal.show" :closable="false" footer-hide>
            <Row>
              <Col span="24">
                <p
                  style="
                    font-size: 16px;
                    font-weight: bold;
                    padding: 0 0 12px;
                    white-space: pre-line;
                  "
                >
                  定型文リスト名の変更
                </p>
              </Col>
            </Row>
            <Form>
              <FormItem label="">
                <Input
                  v-model="editListModal.data.name"
                  ref="nameOfListToBeUpdated"
                ></Input>
              </FormItem>
            </Form>
            <Row style="margin: 24px 0 0">
              <Col span="24">
                <Button type="text" @click="editListModal.show = false"
                  >キャンセル</Button
                >
                <Button
                  type="primary"
                  style="float: right"
                  @click="updateFixedJournalList"
                  :disabled="
                    editListModal.data.name == null ||
                    isEmpty(editListModal.data.name)
                  "
                  >変更する</Button
                >
              </Col>
            </Row>
          </Modal>
          <Modal v-model="deleteListModal.show" :closable="false" footer-hide>
            <div>
              <Row>
                <Col span="24">
                  <p
                    style="
                      font-size: 16px;
                      font-weight: bold;
                      padding: 0 0 12px;
                      white-space: pre-line;
                    "
                  >
                    定型文リストの削除
                  </p>
                  <p>以下の定型文リストを削除します。よろしいですか？</p>
                  <p style="font-size: 16px; font-weight: bold">
                    「{{ omitDisplayName(deleteListModal.data.name) }}」
                  </p>
                </Col>
              </Row>
              <Row style="margin: 24px 0 0">
                <Col span="24">
                  <Button type="text" @click="deleteListModal.show = false"
                    >キャンセル</Button
                  >
                  <Button
                    type="error"
                    style="float: right"
                    @click="deleteFixedJournalList"
                    >削除する</Button
                  >
                </Col>
              </Row>
            </div>
          </Modal>
          <Modal v-model="createModal.show" :closable="false" footer-hide>
            <Row>
              <Col span="24">
                <p
                  style="
                    font-size: 16px;
                    font-weight: bold;
                    padding: 0 0 12px;
                    white-space: pre-line;
                  "
                >
                  定型文の追加
                </p>
              </Col>
            </Row>
            <span
              >同時に複数の定型文を入力する際は、複数行にわけて入力してください。<br />入力された定型文は、改行ごとに分離して保存されます。</span
            >
            <p
              style="margin-top: 10px; text-align: right;"
              v-bind:class="{ red: createModal.data.wordCount > 40 }">
              <span v-show="createModal.data.wordCount > 40" style="font-size: 11px;">（※ 1行あたりの文字数超過のため、スクロール表示します）</span>
              <span>入力文の文字数: </span>
              <span style="display: inline-block; width: 20px; text-align: right;">{{ createModal.data.wordCount }}</span>
            </p>
            <pre></pre>
            <Form>
              <FormItem label="">
                <Input
                  v-model="createModal.data.name"
                  type="textarea"
                  ref="nameToBeCreated"
                  :rows="10"
                  :placeholder="createModal.placeholder"
                  @on-change="onChangeForWordCount"
                ></Input>
              </FormItem>
            </Form>
            <Row style="margin: 24px 0 0">
              <Col span="24">
                <Button type="text" @click="unsetCreateModalTarget"
                  >キャンセル</Button
                >
                <Button
                  type="primary"
                  style="float: right"
                  @click="createFixedJournal"
                  :disabled="
                    createModal.data.name == null ||
                    createModal.data.name == '' ||
                    isOnlyLine(createModal.data.name)
                  "
                  >追加する</Button
                >
              </Col>
            </Row>
          </Modal>
          <Modal v-model="editModal.show" :closable="false" footer-hide>
            <Row>
              <Col span="24">
                <p
                  style="
                    font-size: 16px;
                    font-weight: bold;
                    padding: 0 0 12px;
                    white-space: pre-line;
                  "
                >
                  定型文の変更
                </p>
              </Col>
            </Row>
            <Row>
              <p
                  style="margin-bottom: 5px; text-align: right; width: 100%;"
                  v-bind:class="{ red: editModal.data.wordCount > 40 }">
                  <span v-show="editModal.data.wordCount > 40" style="font-size: 11px;">（※ 1行あたりの文字数超過のため、スクロール表示します）</span>
                  <span>入力文の文字数: </span>
                  <span style="display: inline-block; width: 20px; text-align: right;">{{ editModal.data.wordCount }}</span>
              </p>
            </Row>
            <Form @submit.prevent>
              <FormItem label="">
                <Input
                  v-model="editModal.data.name"
                  ref="nameToBeUpdated"
                  type="text"
                  @on-change="onChangeForWordCountEdit"
                ></Input>
              </FormItem>
            </Form>
            <Row style="margin: 24px 0 0">
              <Col span="24">
                <Button type="text" @click="editModal.show = false"
                  >キャンセル</Button
                >
                <Button
                  type="primary"
                  style="float: right"
                  @click="updateFixedJournal"
                  :disabled="
                    editModal.data.name == null || editModal.data.name == ''
                  "
                  >変更する</Button
                >
              </Col>
            </Row>
          </Modal>
          <Modal v-model="deleteModal.show" :closable="false" footer-hide>
            <Row>
              <Col span="24">
                <p
                  style="
                    font-size: 16px;
                    font-weight: bold;
                    padding: 0 0 12px;
                    white-space: pre-line;
                  "
                >
                  定型文の削除
                </p>
                <p>以下の定型文を削除します。よろしいですか？</p>
                <p style="font-size: 16px; font-weight: bold">
                  「{{ omitDisplayName(deleteModal.data.name) }}」
                </p>
              </Col>
            </Row>
            <Row style="margin: 24px 0 0">
              <Col span="24">
                <Button type="text" @click="deleteModal.show = false"
                  >キャンセル</Button
                >
                <Button
                  type="error"
                  style="float: right"
                  @click="deleteFixedJournal"
                  >削除する</Button
                >
              </Col>
            </Row>
          </Modal>
          <Modal v-model="editColorModal.show" :closable="false" footer-hide>
            <Row>
              <Col span="24">
                <p
                  style="
                    font-size: 16px;
                    font-weight: bold;
                    padding: 0 0 12px;
                    white-space: pre-line;
                  "
                >
                  背景色を変更
                </p>
                背景色を選択してください
                <div class="color-options">
                  <div
                    v-for="color in colorOptions"
                    :key="color"
                    :style="{ backgroundColor: color }"
                    class="color-box"
                    @click="selectColor(color)"
                  >&nbsp;</div>
                </div>
              </Col>
            </Row>
            <Row style="margin: 24px 0 0">
              <Col span="12">
                <Button type="text" @click="unsetEditColorModalTarget">キャンセル</Button>
              </Col>
              <Col span="12" style="text-align: end;">
                <Button type="text" @click="selectColor('#FFFFFF')">リセット</Button>
              </Col>
            </Row>
          </Modal>
        </Col>
        <Col span="4"></Col>
      </Row>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import draggable from 'vuedraggable'

import Header from '../components/dashboard/Header.vue'
import Sidebar from '../components/dashboard/Sidebar.vue'

import { formatDate } from '../utils'

export default {
  components: { draggable, Header, Sidebar },
  data() {
    return {
      colorOptions: [
        "#FECACA",
        "#FEEBCB",
        "#FEFCBF",
        "#D9F99D",
        "#B2F5EA",
        "#BEE3F8",
        "#C4F1F9",
        "#E9D8FD",
        "#FBCFE8",
        "#EEEEEE"
      ],
      createListModal: {
        show: false,
        data: { name: null },
      },
      editListModal: {
        show: false,
        data: { name: null, fixedJournalListId: null },
      },
      deleteListModal: {
        show: false,
        data: { name: null, fixedJournalListId: null },
      },
      createModal: {
        show: false,
        placeholder: '例: 定型文A\n例: 定型文B',
        data: { name: null, fixedJournalListId: null, selectionStart: 0, wordCount: 0 },
      },
      editModal: {
        show: false,
        data: { name: null, fixedJournalId: null, fixedJournalListId: null, wordCount: 0, isComposing: false },
      },
      deleteModal: {
        show: false,
        data: { name: null, fixedJournalId: null, fixedJournalListId: null },
      },
      editColorModal: {
        show: false,
        data: { color: null, fixedJournalListId: null },
      },
      fixedJournalListsAfterSort: [],
      fixedJournalsAfterSort: [],
    }
  },
  watch: {
    'createListModal.show'(val) {
      if (val) {
        this.$nextTick(() => this.$refs.nameOfListToBeCreated.focus())
      }
    },
    'editListModal.show'(val) {
      if (val) {
        this.$nextTick(() => this.$refs.nameOfListToBeUpdated.focus())
      }
    },
    'createModal.show'(val) {
      if (val) {
        this.$nextTick(() => this.$refs.nameToBeCreated.focus())
      }
    },
    'editModal.show'(val) {
      if (val) {
        // モーダルが開かれる時の処理
        this.$nextTick(() => this.$refs.nameToBeUpdated.focus())
        // 文字数
        this.editModal.data.wordCount = this.editModal.data.name.length;
      }
    },
  },
  computed: {
    ...mapGetters(['fixedJournalLists']),
    ...mapGetters({
      previousWorkspaceId: 'fixedJournals/previousWorkspaceId',
    }),
    sortedFixedJournalLists: {
      get() {
        return this.fixedJournalLists
          .filter((list) => list.channel_id == this.currentChannelId)
          .sort((i, j) => i.order - j.order)
      },
      set(value) {
        const channelId = this.currentChannelId
        const data = value.map((l, idx) => {
          return {
            id: l.id,
            order: idx + 1,
          }
        })
        this.$store.dispatch('batchUpdateFixedJournalList', {
          channelId,
          data,
        })
      },
    },
    currentChannelId() {
      return this.$route.params.channelId
    },
  },
  filters: {
    formatDate,
  },
  methods: {
    ...mapActions(['fetchAllFixedJournalList']),
    jumpToListOf(index) {
      const rect = this.$refs['fixed_journal_list_' + index][0].$el.getBoundingClientRect()
      window.scrollTo({top: rect.top})
    },
    sortedFixedJournals(fixedJournalList) {
      // 本当は computed で実現したいが fixedJournalList が v-for 内で変わるため method として呼び出す
      return fixedJournalList.fixed_journals.sort((i, j) => i.order - j.order)
    },
    convertToMultiple(text) {
      return text.split('\n').filter((i) => i.length > 0)
    },
    previousPage() {
      let to = '/'
      if (this.currentChannelId && this.previousWorkspaceId) {
        to = `/dashboard/${this.currentChannelId}/${this.previousWorkspaceId}`
      }
      this.$router.replace(to)
    },
    isEmpty(name) {
      const work = name.replace(/\s+/g, '')
      return work == ''
    },
    isOnlyLine(name) {
      const array = this.convertToMultiple(name)
      return array.length == 0
    },
    omitDisplayName(name) {
      if (name && name.length > 35) {
        return name.substring(0, 34) + '...'
      }
      return name
    },
    setEditListModalTarget(fixedJournalList) {
      this.editListModal.show = true
      this.editListModal.data.name = fixedJournalList.name
      this.editListModal.data.fixedJournalListId = fixedJournalList.id
    },
    unsetEditListModalTarget() {
      this.editListModal.show = false
      this.editListModal.data.name = null
      this.editListModal.data.fixedJournalListId = null
    },
    setDeleteListModalTarget(fixedJournalList) {
      this.deleteListModal.show = true
      this.deleteListModal.data.name = fixedJournalList.name
      this.deleteListModal.data.fixedJournalListId = fixedJournalList.id
    },
    unsetDeleteListModalTarget() {
      this.deleteListModal.show = false
      this.deleteListModal.data.name = null
      this.deleteListModal.data.fixedJournalListId = null
    },
    setCreateModalTarget(fixedJournalListId) {
      this.createModal.show = true
      this.createModal.data.fixedJournalListId = fixedJournalListId
      this.createModal.data.selectionStart = 0
      this.createModal.data.wordCount = 0
    },
    unsetCreateModalTarget() {
      this.createModal.show = false
      this.createModal.data.name = null
      this.createModal.data.fixedJournalListId = null
    },
    setEditModalTarget(fixedJournalListId, fixedJournal) {
      this.editModal.show = true
      this.editModal.data.fixedJournalListId = fixedJournalListId
      this.editModal.data.name = fixedJournal.name
      this.editModal.data.fixedJournalId = fixedJournal.id
    },
    unsetEditModalTarget() {
      this.editModal.show = false
      this.editModal.data.fixedJournalListId = null
      this.editModal.data.name = null
      this.editModal.data.fixedJournalId = null
    },
    setDeleteModalTarget(fixedJournalListId, fixedJournal) {
      this.deleteModal.show = true
      this.deleteModal.data.fixedJournalListId = fixedJournalListId
      this.deleteModal.data.name = fixedJournal.name
      this.deleteModal.data.fixedJournalId = fixedJournal.id
    },
    unsetDeleteModalTarget() {
      this.deleteModal.show = false
      this.deleteModal.data.fixedJournalListId = null
      this.deleteModal.data.name = null
      this.deleteModal.data.fixedJournalId = null
    },
    setEditColorModalTarget(fixedJournalList) {
      this.editColorModal.show = true
      this.editColorModal.data.color = fixedJournalList.color
      this.editColorModal.data.fixedJournalListId = fixedJournalList.id
    },
    unsetEditColorModalTarget() {
      this.editColorModal.show = false
      this.editColorModal.data.color = null
      this.editColorModal.data.fixedJournalListId = null
    },
    updateFixedJournalOrder(e) {
      // v-for で FixedJournalList が変化するのでこのアプローチで対応
      const channelId = this.currentChannelId
      const fixedJournalListId = e.moved.element.fixed_journal_list_id
      const data = this.sortedFixedJournalLists
        .filter((l) => l.id == fixedJournalListId)[0]
        .fixed_journals.map((j, idx) => {
          return {
            id: j.id,
            order: idx + 1,
          }
        })
      this.$store.dispatch('batchUpdateFixedJournal', {
        channelId,
        fixedJournalListId,
        data,
      })
    },
    getMaximumOrder(channelId, fixedJournalListId) {
      const list = this.fixedJournalLists.filter(
        (l) => l.channel_id == channelId && l.id == fixedJournalListId
      )[0]
      const a = list.fixed_journals.map((j) => j.order)
      if (a.length == 0) return 0
      const maximumOrder = Math.max(...a)
      return maximumOrder
    },
    async createFixedJournalList() {
      if (this.createListModal.data.name) {
        await this.$store.dispatch('createFixedJournalList', {
          channelId: this.currentChannelId,
          fixedJournalListInput: {
            id: '', // idはbackendに生成してもらう
            name: this.createListModal.data.name,
            meta: {},
            color: '',
          },
        })
      }
      this.createListModal.show = false
      this.createListModal.data.name = null
    },
    async updateFixedJournalList() {
      if (this.editListModal.data.name) {
        await this.$store.dispatch('updateFixedJournalList', {
          channelId: this.currentChannelId,
          fixedJournalListId: this.editListModal.data.fixedJournalListId,
          fixedJournalListInput: {
            name: this.editListModal.data.name,
          },
        })
      }
      this.unsetEditListModalTarget()
    },
    async deleteFixedJournalList() {
      await this.$store.dispatch('deleteFixedJournalList', {
        channelId: this.currentChannelId,
        fixedJournalListId: this.deleteListModal.data.fixedJournalListId,
      })
      this.unsetDeleteListModalTarget()
    },
    async createFixedJournal() {
      const array = this.convertToMultiple(this.createModal.data.name)
      let order = this.getMaximumOrder(
        this.currentChannelId,
        this.createModal.data.fixedJournalListId
      )
      array.forEach(async (name) => {
        order += 1
        await this.$store.dispatch('createFixedJournal', {
          channelId: this.currentChannelId,
          fixedJournalListId: this.createModal.data.fixedJournalListId,
          fixedJournalInput: {
            id: '', // idはbackendに生成してもらう
            name: name,
            meta: {},
            order,
          },
        })
      })
      this.unsetCreateModalTarget()
    },
    async updateFixedJournal() {
      if (this.editModal.data.name) {
        await this.$store.dispatch('updateFixedJournal', {
          channelId: this.currentChannelId,
          fixedJournalListId: this.editModal.data.fixedJournalListId,
          fixedJournalId: this.editModal.data.fixedJournalId,
          fixedJournalInput: {
            name: this.editModal.data.name,
          },
        })
      }
      this.unsetEditModalTarget()
    },
    async deleteFixedJournal() {
      await this.$store.dispatch('deleteFixedJournal', {
        channelId: this.currentChannelId,
        fixedJournalListId: this.deleteModal.data.fixedJournalListId,
        fixedJournalId: this.deleteModal.data.fixedJournalId,
      })
      this.unsetDeleteModalTarget()
    },
    dispatchFocusIsNotOnButton(event) {
      if (this.createListModal.show) {
        this.createFixedJournalList()
      }
      if (this.editListModal.show) {
        this.updateFixedJournalList()
      }
      if (this.deleteListModal.show) {
        this.deleteListModal.show = false
      }
      // createModal だけは Enter を改行として受け付ける必要があるため対象外とする
      // if (this.createModal.show) {}
      if (this.editModal.show) {
        this.updateFixedJournal()
      }
      if (this.deleteModal.show) {
        this.deleteModal.show = false
      }
    },
    calcNumOfCharsAtCurrPos(selectionStart) {
      // console.log(`selectionStart: ${selectionStart}`)
      // console.dir(this.createModal.data.name)
      const idxOfLine = this.createModal.data.name.indexOf("\n", selectionStart)
      // console.log(`idxOfLine: ${idxOfLine}`)
      const lastIdxOfLine = this.createModal.data.name.lastIndexOf("\n", selectionStart)
      // console.log(`lastIdxOfLine: ${lastIdxOfLine}`)
      // console.log(`name.length: ${this.createModal.data.name.length}`)
      if (idxOfLine != -1) {
          if (lastIdxOfLine != -1) {
            // console.log(1)
            this.createModal.data.wordCount = idxOfLine - lastIdxOfLine - 1
          } else {
            // console.log(2)
            this.createModal.data.wordCount = idxOfLine
          }
      } else {
          if (lastIdxOfLine != -1) {
            // console.log(3)
            this.createModal.data.wordCount = this.createModal.data.name.length - lastIdxOfLine - 1
          } else {
            // console.log(4)
            this.createModal.data.wordCount = this.createModal.data.name.length
          }
      }
      if (selectionStart == idxOfLine) {
        const lastIdxOfLine2 = this.createModal.data.name.lastIndexOf("\n", selectionStart - 1)
        // console.log(`lastIdxOfLine2: ${lastIdxOfLine2}`)
        if (lastIdxOfLine2 != -1) {
          // console.log(5)
          this.createModal.data.wordCount = lastIdxOfLine - lastIdxOfLine2 - 1
        } else {
          // console.log(6)
          this.createModal.data.wordCount = idxOfLine
        }
      }
    },
    handleKeyDown(event) {
      if (this.createModal.show == false && event.key == 'Enter') {
        // createModal だけは Enter を改行として受け付ける必要があるため対象外とする
        event.preventDefault() // Enter キーで画面がリロードしてしまうのを無効化
        const focusedElement = document.activeElement
        if (focusedElement.className.includes('ivu-btn')) {
          // キャンセルまたは確定ボタンにフォーカスが当たっていたら
          focusedElement.click() // そのアクションを呼び出す
        }
      }
    },
    handleKeyUp(event) {
      if (this.createModal.show) {
        this.createModal.data.selectionStart = event.srcElement.selectionStart
        this.calcNumOfCharsAtCurrPos(event.srcElement.selectionStart)
      }
    },
    onChangeForWordCount() {
      this.calcNumOfCharsAtCurrPos(event.srcElement.selectionStart)
    },
    onChangeForWordCountEdit() {
      this.editModal.data.wordCount = this.editModal.data.name.length
    },
    async onChangeHeaderColor() {
      this.editColorModal.show = false
      await this.$store.dispatch('updateFixedJournalList', {
        channelId: this.currentChannelId,
        fixedJournalListId: this.editColorModal.data.fixedJournalListId,
        fixedJournalListInput: {
          color: this.editColorModal.data.color,
        },
        hasToUpdateTime: false
      })
      this.updateHeadersColor()
    },
    onOpenChange() {
      setTimeout(() => {
        const btns = this.$refs.colorPicker.$el.getElementsByTagName('button')
        if (btns.length == 2) {
          btns[0].innerText = '解除'
          btns[1].innerText = '決定'
	}
      }, 100)
    },
    updateHeadersColor() {
      const headers = this.$el.getElementsByClassName('ivu-card-head')
      for (let i = 0; i < headers.length; i++) {
        const ID = headers[i].parentElement.id
        const hits = this.fixedJournalLists.filter((i) => i.id == ID)
        if (hits.length == 1) {
          headers[i].style.backgroundColor = hits[0].color
        }
      }
      this.unsetEditColorModalTarget()
    },
    selectColor(color) {
      this.editColorModal.data.color = color
      this.onChangeHeaderColor()
    },
  },
  async mounted() {
    this.updateHeadersColor()
    await this.fetchAllFixedJournalList({ channelId: this.currentChannelId })
    this.updateHeadersColor()
    window.addEventListener('keydown', this.handleKeyDown)
    window.addEventListener('keyup', this.handleKeyUp)
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.handleKeyDown)
    window.removeEventListener('keyup', this.handleKeyUp)
  },
}
</script>
<style lang="less">
html,
body {
  height: 100%;
  background-color: #f8f8f9;
}
.color-options {
  display: flex;
  flex-direction: row;
  gap: 10px;
  margin-top: 10px;
  }

.color-box {
width: 40px;
height: 40px;
cursor: pointer;
border: 1px solid #ccc;
flex-shrink: 0;  /* Prevent shrinking in flexbox */
}
</style>

<style lang="less" scoped>
.root {
  .container {
    padding-top: 50px;
  }

  .empty {
    background-color: #eee;
    height: 100px;
    text-align: center;
  }
  .list-item-container {
    overflow: auto;
  }
  .fixed-journal {
    display: flex;
  }
  .space {
    flex: 1;
  }
  .two-columns {
    width: 100%;
    display: grid;
    grid-template-columns: 1fr 1fr;
  }
  .text {
    font-weight: bold;
  }
  .action {
    font-size: 11px;
  }
  /* Webkitブラウザ向けのスクロールバー非表示 */
  ::-webkit-scrollbar {
    width: 0.5em;
    background-color: transparent;
  }

  /* Webkitブラウザ向けのスクロールバーのスライダー部分非表示 */
  ::-webkit-scrollbar-thumb {
    background-color: transparent;
  }

  /* Webkitブラウザ向けのスクロールバーのボタン部分非表示 */
  ::-webkit-scrollbar-button {
    display: none;
  }

  .sortable {
    cursor: move;
  }
}
</style>
